import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    meta: {
      title: process.env.VUE_APP_NAME
    },
    component: () => import("../views/Home.vue")
  },
  {
    path: "/form/:kriteria_id/:sub_id",
    name: "form",
    meta: {
      title: "Form | " + process.env.VUE_APP_NAME
    },
    component: () => import("../views/Form.vue")
  },
  // Admin
  {
    path: "/admin/rekap",
    name: "admin-rekap",
    meta: {
      title: "Rekap | " + process.env.VUE_APP_NAME
    },
    component: () => import("../views/Admin/Rekap.vue")
  },
  {
    path: "/admin/kriteria",
    name: "admin-kriteria",
    meta: {
      title: "Kriteria | " + process.env.VUE_APP_NAME
    },
    component: () => import("../views/Admin/Kriteria.vue")
  },
  {
    path: "/admin/sub-kriteria",
    name: "admin-subkriteria",
    meta: {
      title: "Sub Kriteria | " + process.env.VUE_APP_NAME
    },
    component: () => import("../views/Admin/SubKriteria.vue")
  },
  {
    path: "/not-allowed",
    meta: {
      title: "Halaman tidak diijinkan | " + process.env.VUE_APP_NAME
    },
    component: () => import("../views/NotAllowed.vue")
  },
  {
    // not found handler
    path: "*",
    meta: {
      title: "Halaman tidak ditemukan | " + process.env.VUE_APP_NAME
    },
    component: () => import("../views/NotFound.vue")
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  next();
});

export default router;
